import React, {useEffect, useState} from 'react'
import {useNavigate} from 'react-router'
import {IntlShape, useIntl} from 'react-intl'
import {useChangeLocale} from '../LocalizationContext'
import {Link, useNavigation} from 'react-router-dom'
import type {CollapseProps} from 'antd'
import {Menu, MenuProps, Button, Carousel, List, Collapse} from 'antd'
//import urlHeroImage from 'url:../../../public/assets/images/house_garden_ar1.webp'
import urlHeroImage from 'url:../../../public/assets/images/hiwor.png'
import iconImage1 from 'url:../../../public/assets/images/icon1w.png'
import iconImage2 from 'url:../../../public/assets/images/icon2w.png'
import iconImage3 from 'url:../../../public/assets/images/icon3w.png'
import iconImage4 from 'url:../../../public/assets/images/icon4w.png'
import iconPortal from 'url:../../../public/assets/images/iconPortal2.svg'
import logoIcon from 'url:../../../public/assets/images/logo11c.svg'
import editorImage from 'url:../../../public/assets/images/editor-image-car.png'
import editorImage1 from 'url:../../../public/assets/images/editor-image-car1.png'
import editorImage2 from 'url:../../../public/assets/images/editor-image-car2.png'
import editorImage3 from 'url:../../../public/assets/images/editor-image-car3.png'
import imageToDos from 'url:../../../public/assets/images/imageToDos.png'
import imageSlider1 from 'url:../../../public/assets/images/hydrangea.jpg'
import imageSlider2 from 'url:../../../public/assets/images/barbaris.jpg'
import imageSlider3 from 'url:../../../public/assets/images/astra.jpg'
import imageSlider4 from 'url:../../../public/assets/images/crocus.jpg'
import imageSlider5 from 'url:../../../public/assets/images/dasiphora.jpg'
import imageSlider6 from 'url:../../../public/assets/images/anemone.jpg'
import imageSlider7 from 'url:../../../public/assets/images/sedum.jpg'
import './landing.less'
import Icon, {GlobalOutlined, InstagramOutlined, MenuOutlined} from '@ant-design/icons'
import {PlantCard, PlantCardProps} from '../plantsGallery/PlantCard'
import {CardSlider} from './CardSlider'

import {instance as userService} from '../../services/UserService'

export function LandingPage() {
  const intl = useIntl()
  const navigation = useNavigation()
  const navigate = useNavigate()

  const changeLocale = useChangeLocale()

  const items: MenuProps['items'] = [
    {label: intl.formatMessage({id: 'editor'}), key: 'editor'},
    {label: intl.formatMessage({id: 'taskPlanner'}), key: 'taskPlanner'},
    {label: intl.formatMessage({id: 'plantDatabase'}), key: 'plantDatabase'},
    {
      icon: (
        <div id="language-icon">
          <GlobalOutlined />
        </div>
      ),
      key: 'language',
      children: [
        {label: 'en', key: 'en', onClick: () => changeLocale('en')},
        {label: 'ru', key: 'ru', onClick: () => changeLocale('ru')},
      ],
    },
  ]

  const questionsWithAnswers: CollapseProps['items'] = [
    {
      key: '1',
      label: intl.formatMessage({id: 'faqQuestion1'}),
      children: <p>{intl.formatMessage({id: 'faqAnswer1'})}</p>,
    },
    {
      key: '2',
      label: intl.formatMessage({id: 'faqQuestion2'}),
      children: <p>{intl.formatMessage({id: 'faqAnswer2'})}</p>,
    },
    {
      key: '3',
      label: intl.formatMessage({id: 'faqQuestion3'}),
      children: <p>{intl.formatMessage({id: 'faqAnswer3'})}</p>,
    },
    {
      key: '4',
      label: intl.formatMessage({id: 'faqQuestion4'}),
      children: <p>{intl.formatMessage({id: 'faqAnswer4'})}</p>,
    },
  ]

  const plantCardsInfo: PlantCardProps[] = [
    {
      photo: imageSlider1,
      sun: 2,
      watering: 3,
      name: intl.formatMessage({id: 'landingPlantHydrangea'}),
      description: 'Hydrangea macrophylla',
    },
    {
      photo: imageSlider2,
      sun: 2,
      watering: 3,
      name: intl.formatMessage({id: 'landingPlantBerberis'}),
      description: 'Berberis thunbergii',
    },
    {
      photo: imageSlider3,
      sun: 2,
      watering: 3,
      name: intl.formatMessage({id: 'landingPlantSymphotrichum'}),
      description: 'Symphyotrichum dumosum',
    },
    {
      photo: imageSlider4,
      sun: 2,
      watering: 3,
      name: intl.formatMessage({id: 'landingPlantCrocus'}),
      description: 'Crocus',
    },
    {
      photo: imageSlider5,
      sun: 2,
      watering: 3,
      name: intl.formatMessage({id: 'landingPlantDasiphora'}),
      description: 'Dasiphora fruticosa',
    },
    {
      photo: imageSlider6,
      sun: 2,
      watering: 3,
      name: intl.formatMessage({id: 'landingPlantAnemone'}),
      description: 'Anemone hybrida',
    },
    {
      photo: imageSlider7,
      sun: 2,
      watering: 3,
      name: intl.formatMessage({id: 'landingPlantSedum'}),
      description: 'Sedum spectabile',
    },
  ]

  const onClick: MenuProps['onClick'] = (e) => {
    var elem = document.getElementById(e.key)
    if (elem) {
      var jump = elem.getBoundingClientRect().top
      document.body.scrollTop += jump
      document.documentElement.scrollTop += jump
    }
  }

  return (
    <div className="layout">
      <div
        className="hero-image"
        style={{
          backgroundImage: `url('${urlHeroImage}')`,
        }}
      />

      <div className="menu">
        <div className="menu__row">
          <div className="menu__row__logo">
            <Link to="/">
              <h1>
                <img src={logoIcon}></img>
              </h1>
            </Link>
          </div>
          <Menu
            className="menu__row__items"
            mode="horizontal"
            overflowedIndicator={<MenuOutlined />}
            items={items}
            onClick={onClick}
          />
          <Button
            onClick={async () => {
              navigate('/login')
            }}
          >
            {intl.formatMessage({id: 'logIn'})}
          </Button>
        </div>
      </div>

      <div className="hero-content">
        <div className="hero-content__info">
          <h2 className="hero-content__info__slogan">
            {intl.formatMessage({id: 'sloganElevate'})}
          </h2>
          <div className="hero-content__info__subslogan">
            {intl.formatMessage({id: 'subSloganElevate'})}
          </div>
          <Button
            className="hero-content__info__button"
            size="large"
            onClick={async () => {
              navigate('/signup')
            }}
          >
            {intl.formatMessage({id: 'startToday'})}
          </Button>
        </div>
      </div>

      <div className="features">
        {[
          {
            icon: iconImage1,
            text: intl.formatMessage({id: 'onlineEditor'}),
            subtext: intl.formatMessage({id: 'onlineEditorDescription'}),
          },
          {
            icon: iconImage2,
            text: intl.formatMessage({id: 'taskPlanner'}),
            subtext: intl.formatMessage({id: 'taskPlannerDescription'}),
          },
          {
            icon: iconImage3,
            text: intl.formatMessage({id: '1000Plants'}),
            subtext: intl.formatMessage({id: '1000PlantsDescription'}),
          },
          {
            icon: iconImage4,
            text: intl.formatMessage({id: 'gardenJournal'}),
            subtext: intl.formatMessage({id: 'gardenJournalDescription'}),
          },
        ].map((f, index) => (
          <div className="features__item" key={index}>
            <div className="features__item__icon">
              <img src={f.icon}></img>
            </div>
            <h3>{f.text}</h3>

            <h4>{f.subtext}</h4>
          </div>
        ))}
      </div>

      <div id="editor" className="content">
        <div className="content__header">
          <h3>{intl.formatMessage({id: 'terraSketchEditor'})}</h3>
        </div>
        <div className="content__back">
          <div className="content__back__info">
            <div className="carousel">
              <Carousel autoplay effect="fade" autoplaySpeed={4000}>
                {[editorImage, editorImage1, editorImage2, editorImage3].map((imageUrl, index) => (
                  <div key={index}>
                    <div
                      className="carousel__image"
                      style={{
                        backgroundImage: `url('${imageUrl}')`,
                      }}
                    ></div>
                  </div>
                ))}
              </Carousel>
            </div>
            <div className="content__back__info__item">
              {[
                intl.formatMessage({id: 'terraSketchEditorDescription1'}),
                intl.formatMessage({id: 'terraSketchEditorDescription2'}),
                intl.formatMessage({id: 'terraSketchEditorDescription3'}),
                intl.formatMessage({id: 'terraSketchEditorDescription4'}),
                intl.formatMessage({id: 'terraSketchEditorDescription5'}),
              ].map((text, index) => (
                <div className="content__back__info__item__li" key={index}>
                  <img className="content__back__info__item__li__icon" src={iconPortal}></img>
                  <span className="content__back__info__item__li__text">{text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div id="taskPlanner" className="planner">
        <div className="planner__header">
          <h3>{intl.formatMessage({id: 'terraSketchTaskPlanner'})}</h3>
        </div>
        <div className="planner__list">
          {[
            intl.formatMessage({id: 'terraSketchTaskPlannerDescription1'}),
            intl.formatMessage({id: 'terraSketchTaskPlannerDescription2'}),
            intl.formatMessage({id: 'terraSketchTaskPlannerDescription3'}),
            intl.formatMessage({id: 'terraSketchTaskPlannerDescription4'}),
          ].map((text, index) => (
            <div className="planner__list__item" key={index}>
              <img src={iconPortal}></img>
              <span>{text}</span>
            </div>
          ))}
        </div>
        <div className="planner__image">
          <img src={imageToDos}></img>
        </div>
      </div>

      <div id="plantDatabase" className="plants">
        <div className="plants__header">
          <h3>{intl.formatMessage({id: 'terraSketchPlantDatabase'})}</h3>
        </div>
        <div className="plants__subheader">
          {intl.formatMessage({id: 'terraSketchPlantDatabaseDescription'})}
        </div>
        <div className="plants__slider">
          <CardSlider plants={plantCardsInfo} slidesPerView={5}></CardSlider>
        </div>
      </div>

      <div id="faq">
        <div className="faq">
          <h3>{intl.formatMessage({id: 'faq'})}</h3>
        </div>
        <Collapse className="faq__collapse" items={questionsWithAnswers} defaultActiveKey={['1']} />
      </div>

      <div className="footer">
        <div className="footer__left">
          <Link to="/#">TerraSketch</Link>
        </div>
        <div className="footer__right">
          <Link to="/policies">{intl.formatMessage({id: 'policy'})}</Link>
          <Link to="mailto:terrasketch.info@gmail.com">{intl.formatMessage({id: 'emailUs'})}</Link>
          <Link to="/#">
            <InstagramOutlined />
          </Link>
        </div>
      </div>
    </div>
  )
}
